var render, staticRenderFns
import script from "./CQOptionsRadioSmall.vue?vue&type=script&lang=js&"
export * from "./CQOptionsRadioSmall.vue?vue&type=script&lang=js&"
import style0 from "./CQOptionsRadioSmall.vue?vue&type=style&index=0&id=5976b56b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports